import React from 'react';
import { useTranslation } from 'react-i18next';

import { WarnModal } from '@/components/elements';
                          
interface Props {
  onSubmit?: () => void;
  onSetVisible: (value: boolean) => void;  
}

const LettersOfMedicalNecessityErrorPopup: React.FC<Props> = ({ onSubmit, onSetVisible }) => {
  const { t } = useTranslation();

  return (
    <WarnModal
      testId="letters-of-medical-necessity-error-popup"
      visible
      onSetVisible={onSetVisible}
      header={t('The server encountered an error processing the request')}
      helptext={t(`It does not appear to have affected your data, but we cannot process your request.
                  Our technical stuff has been automatically and will be looking into this with the utmost urgency.`)}
      buttonText="Close"
      onSubmit={onSubmit}
      submitButtonText="Try again"
      isAwaitMode
      disableAutomaticClosing
    />
  );
};

export default LettersOfMedicalNecessityErrorPopup;
